export default __webpack_public_path__ + "static/media/contactManagerSVG.691c6148.svg";